import { render, staticRenderFns } from "./GpathAptitudeRecoAdd.vue?vue&type=template&id=177c8f97&scoped=true"
import script from "./GpathAptitudeRecoAdd.vue?vue&type=script&lang=js"
export * from "./GpathAptitudeRecoAdd.vue?vue&type=script&lang=js"
import style0 from "./GpathAptitudeRecoAdd.vue?vue&type=style&index=0&id=177c8f97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177c8f97",
  null
  
)

export default component.exports